import { RegionAuditList } from './views';

export default {
  list: RegionAuditList,
  name: 'region-audit',
  // No 'label' property = hidden from menu per react-admin Resource behavior
};
